<template>
		<div class="upgradetopracticemodalmessage" @click="onClose({status:false})">
            <div  class="upgradetopremium">
                        <div class="upgradetopremiummodal">
                            <div class="sorry-title">Sorry!</div>
                            <div class="modal-text">You don't have access to this feature yet.</div>
                            <div class="modal-text"><b>Boost Up!</b><span class="Practice-Session"></span> now to get access to this feature and much more!</div>
                            <div>
                                <div class="freetrial"> 
                                <v-btn v-if="!user.is_boostup_free_trail_used" class="try-later" color="#3EB0E8" @click="onClose({status:false})">Try Later</v-btn>
                                <v-btn v-if="!user.is_boostup_free_trail_used" class="free-trial" color="#303E9F" @click="buyNow(productId)">Free Trial</v-btn>
                                </div>
                                <v-btn color="#EEBC1D" class="yellow-btn" @click="onClickUpgrade()">Upgrade Now</v-btn>
                            </div>
                    </div>
            </div>
        </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import constants from "@/utils/constants.js";
import moment from 'moment';

export default {
    name: "UpGradeToPracticeSessionPopUp",
    props: ["onClose", "status", "data", "onCustomizeClick"],
    data() {
        return {
            dummyOptions: [],
            dummyOptionsABC: [],
            dummyOptionsPQR: [],
            subQuestionLength: 0,
            disableCreateTest: false,
            showCustomizeSyllabus: false,
            displayClass: "upgradetopremium",
            productId: constants.BOOSTUP_PRODUCT_ID_FREE_TRIAL,
        };
    },
    mounted() {
    },
    computed: {
    ...mapState("userStore", ["user"]),
    },
    methods: {
    ...mapActions({
      createPackageOrder: "userStore/createPackageOrder",
    }),
    onClickUpgrade() {
        this.$router.push({
              name: "my-subscription",
            });
    },
    buyNow(productId) {
      var pId = [];
      if (productId) {
        pId.push(productId);
      }
      if (pId && pId.length) {
        let success_redirect = window.location.href.split("?")[0];
        let failure_redirect = success_redirect;
        let reqData = {
          product_ids: pId,
          success_redirect,
          failure_redirect,
        };
        this.setEventBeforeUpgrade(constants.EVENT.CREATE_PRACTICE_SESSION)

        this.createPackageOrder(reqData)
          .then((response) => {
            let user = this.user;
            user.is_free_trail = 1
            sessionStorage.setItem("user",JSON.stringify(user));
            this.$root.showLoader = false;
            let expires = (moment().add(constants.BOOSTUP_PRODUCT_ID_FREE_TRIAL_EXPIRY, 'days')).format("DD-MM-YYYY");
            if(productId == 10) {
              this.$toasted.success(`Congratulations!\nYour ${constants.BOOSTUP_PRODUCT_ID_FREE_TRIAL_EXPIRY}-day free trial is activated successfully.\nThe free trial ends on ${expires}`, {});	
              setTimeout(() => this.$router.go(this. $router. currentRoute), 5000);
            }
          })
          .catch((err) => {
            this.$root.showLoader = false;
          });
      } else {
        this.$toasted.error("Please add atleast one package in cart.");
      }
    },
    }
};
</script>